import { render, staticRenderFns } from "./NarutoEyes.vue?vue&type=template&id=2605bca7&scoped=true&"
import script from "./NarutoEyes.vue?vue&type=script&lang=js&"
export * from "./NarutoEyes.vue?vue&type=script&lang=js&"
import style0 from "./NarutoEyes.vue?vue&type=style&index=0&id=2605bca7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605bca7",
  null
  
)

export default component.exports